import PropTypes from "prop-types";
import { Button, Grid, Typography } from "@material-ui/core";
import useStyle from "./style";
import { useState } from "react";
import { Close } from "@material-ui/icons";
import { FIXED_BACKGROUND_FLAG, FIXED_FONT_COLOR_FLAG } from ".";

const AddFile = ({ seal, setSeal }) => {
  const style = useStyle();

  const [files, setFiles] = useState({
    csv: null,
    image: null,
  });

  const isVisible = files.csv || files.image;

  return (
    <Grid className={style.wrapperFiles}>
      <div className={style.files}>
        <div className={style.containerSeal}>
          <Typography variant="h6">Importar planilha</Typography>
          <svg
            width="64"
            height="62"
            viewBox="0 0 64 62"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M34.1833 25.8065H46.9246V31.9725H34.1833V25.8065ZM46.9246 21.4414H34.1833V15.2751H46.9246V21.4414ZM29.8197 21.4414H17.0772V15.2751H29.8195V21.4414H29.8197ZM17.0772 36.3369H29.8195V42.5045H17.0772V36.3369ZM34.1833 36.3369H46.9246V42.5045H34.1833V36.3369ZM46.9246 0.4375V10.9119H17.0772V0.4375H46.9246ZM2.7906 9.19938V49.4076C2.79227 49.7141 2.91477 50.0076 3.13151 50.2243C3.34824 50.4411 3.64172 50.5636 3.94822 50.5653H60.0533C60.36 50.5636 60.6535 50.4411 60.8705 50.2244C61.0874 50.0077 61.2102 49.7142 61.2122 49.4076V9.19938C61.2102 8.89279 61.0873 8.59937 60.8704 8.3827C60.6535 8.16603 60.3599 8.04358 60.0533 8.04188H51.2883C51.2842 8.04438 51.2907 35.7695 51.2883 42.9895C52.2448 49.1095 45.9873 46.2584 31.7443 46.8683C10.7147 46.5571 12.7882 48.822 12.7145 40.517C12.7133 30.907 12.7133 8.052 12.7133 8.042C7.62222 8.24588 2.5436 7.30713 2.7906 9.19938ZM64.001 56.8394C63.3122 63.5269 56.5681 61.2019 53.8182 61.6209H28.3371C4.39822 61.2 -0.356778 64.0275 0.000597073 54.9289H64.0006V56.8388L64.001 56.8394ZM17.0772 25.8065H29.8195V31.9725H17.0772V25.8065Z"
              fill="#FF314A"
            />
          </svg>

          <Typography variant="p">Faça o upload do arquivo ou csv.</Typography>

          <label htmlFor="csv" data-element="import">
            <Typography variant="span">Importar planilha</Typography>
            <svg
              width="5"
              height="9"
              viewBox="0 0 5 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.146447 8.85355C-0.0488155 8.65829 -0.0488155 8.34171 0.146447 8.14645L3.79289 4.5L0.146447 0.853553C-0.0488154 0.658291 -0.0488154 0.341708 0.146447 0.146446C0.341709 -0.0488157 0.658291 -0.0488157 0.853554 0.146446L4.85355 4.14645C5.04882 4.34171 5.04882 4.65829 4.85355 4.85355L0.853553 8.85355C0.658291 9.04882 0.341709 9.04882 0.146447 8.85355Z"
                fill="white"
              />
            </svg>
            <input
              type="file"
              hidden
              id="csv"
              accept=".csv"
              onChange={(e) => {
                setSeal({
                  ...seal,
                  csv: e.target.files[0],
                });

                setFiles({
                  ...files,
                  csv: e.target.files[0],
                });
              }}
            />
          </label>
        </div>

        <div className={style.containerSeal}>
          <Typography variant="h6">Adicionar Selo</Typography>

          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_22261_71814)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.29731 38.5832C4.56112 38.8368 4.75062 39.1577 4.84535 39.5112C4.94008 39.8647 4.93644 40.2374 4.83481 40.5889L3.85231 44.2541C3.5012 45.5658 3.68517 46.9633 4.36379 48.1394C5.04242 49.3156 6.1602 50.1743 7.47156 50.5268L11.3009 51.5518C11.6559 51.6387 11.9803 51.8213 12.2387 52.0798C12.4971 52.3383 12.6795 52.6627 12.7662 53.0178L13.7503 56.6923C14.1042 58.0022 14.9631 59.1183 16.1387 59.7958C17.3143 60.4734 18.7106 60.6571 20.0214 60.3067L23.8508 59.2817C24.2019 59.1809 24.5737 59.1779 24.9264 59.273C25.279 59.3681 25.599 59.5576 25.8518 59.8212L28.5393 62.5067C29.5016 63.4632 30.8034 64 32.1602 64C33.517 64 34.8187 63.4632 35.7811 62.5067L38.5843 59.7034C38.837 59.4395 39.1572 59.2497 39.51 59.1546C39.8629 59.0595 40.235 59.0627 40.5862 59.1639L44.2568 60.1527C45.5686 60.4984 46.9639 60.3115 48.1385 59.6327C49.3131 58.9539 50.1716 57.8383 50.5271 56.5291L51.5532 52.7006C51.64 52.3455 51.8225 52.021 52.0809 51.7625C52.3394 51.504 52.6638 51.3213 53.0188 51.2344L56.6893 50.2547C57.9988 49.8992 59.1145 49.04 59.7928 47.8648C60.4711 46.6896 60.6569 45.2938 60.3097 43.9821L59.2837 40.1536C59.1821 39.802 59.1785 39.4293 59.2732 39.0759C59.3679 38.7224 59.5574 38.4015 59.8212 38.1478L62.5058 35.4624C63.4642 34.502 64.0025 33.2005 64.0025 31.8437C64.0025 30.4868 63.4642 29.1854 62.5058 28.2249L59.7003 25.4176C59.4384 25.1634 59.2504 24.8428 59.1565 24.4901C59.0625 24.1374 59.0661 23.7659 59.1668 23.4151L60.1503 19.7499C60.4996 18.4379 60.3146 17.0409 59.6356 15.8651C58.9567 14.6893 57.8394 13.8306 56.5284 13.4772L52.7064 12.4449C52.3499 12.3621 52.0235 12.1818 51.7634 11.9242C51.5034 11.6667 51.3201 11.3419 51.2339 10.9862L50.2511 7.31243C49.8955 6.00314 49.0368 4.8875 47.8621 4.20875C46.6874 3.53 45.2919 3.3432 43.9801 3.68906L40.1516 4.71406C39.8011 4.81695 39.4291 4.82191 39.0761 4.72839C38.723 4.63487 38.4023 4.44644 38.1487 4.18356L35.4628 1.49756C34.5018 0.538579 33.1996 0 31.842 0C30.4844 0 29.1822 0.538579 28.2212 1.49756L25.4184 4.30081C25.1649 4.56348 24.8444 4.75179 24.4916 4.84537C24.1387 4.93894 23.767 4.93421 23.4167 4.83168L19.7461 3.85181C18.4341 3.50213 17.037 3.68723 15.8614 4.36649C14.6857 5.04575 13.8276 6.16368 13.4753 7.47493L12.4486 11.3037C12.3617 11.659 12.1789 11.9836 11.9202 12.2422C11.6615 12.5007 11.3367 12.6832 10.9813 12.7698L7.31281 13.7499C6.00139 14.1024 4.88353 14.961 4.20484 16.1372C3.52616 17.3134 3.34217 18.7109 3.69331 20.0227L4.71831 23.8512C4.81951 24.2018 4.8234 24.5734 4.72958 24.9261C4.63575 25.2788 4.44774 25.5993 4.18568 25.8533L1.49468 28.5419C0.536291 29.5024 -0.00195313 30.8038 -0.00195312 32.1607C-0.00195313 33.5175 0.536291 34.819 1.49468 35.7794L4.29706 38.5827L4.29731 38.5832ZM28.2236 39.1332C27.8216 39.1035 27.4478 38.9153 27.1846 38.6101L21.7149 32.2776C21.463 31.9701 21.341 31.5764 21.3751 31.1804C21.4091 30.7843 21.5965 30.4172 21.8972 30.1573C22.1979 29.8973 22.5883 29.7651 22.9851 29.7887C23.3819 29.8123 23.7538 29.9899 24.0216 30.2837L28.4878 35.4522L40.1274 25.2442C40.2769 25.1089 40.4518 25.0047 40.6419 24.9376C40.832 24.8705 41.0336 24.8418 41.2349 24.8533C41.4362 24.8647 41.6332 24.9161 41.8144 25.0043C41.9957 25.0926 42.1577 25.2159 42.2908 25.3673C42.424 25.5187 42.5258 25.695 42.5903 25.886C42.6548 26.077 42.6806 26.279 42.6664 26.4801C42.6521 26.6812 42.5981 26.8774 42.5073 27.0575C42.4166 27.2375 42.291 27.3977 42.1378 27.5288L29.3427 38.7602C29.0651 39.0051 28.708 39.1408 28.3378 39.1421C28.3009 39.1401 28.2638 39.1352 28.2236 39.1334V39.1332ZM32.0003 17.2416C34.9196 17.2417 37.7733 18.1076 40.2006 19.7296C42.6278 21.3516 44.5196 23.6569 45.6366 26.3541C46.7537 29.0512 47.0458 32.019 46.4762 34.8822C45.9066 37.7454 44.5007 40.3754 42.4364 42.4396C40.372 44.5038 37.742 45.9095 34.8787 46.479C32.0155 47.0485 29.0477 46.7561 26.3506 45.6389C23.6536 44.5217 21.3483 42.6298 19.7265 40.2025C18.1046 37.7751 17.2389 34.9214 17.2389 32.0021C17.2424 28.0882 18.7987 24.3357 21.5663 21.5683C24.3339 18.8009 28.0865 17.2448 32.0003 17.2416ZM32.0003 49.8109C22.1819 49.8109 14.1906 41.8204 14.1906 32.0021C14.1906 22.1789 22.1781 14.1932 32.0003 14.1932C41.8226 14.1932 49.8109 22.1783 49.8109 32.0021C49.8109 41.8211 41.8191 49.8109 32.0003 49.8109Z"
                fill="#1BA441"
              />
            </g>
            <defs>
              <clipPath id="clip0_22261_71814">
                <rect width="64" height="64" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <Typography variant="p">
            Faça o upload da imagem do selo em PNG, JPEG ou GIF
          </Typography>

          <label htmlFor="img" data-element="add">
            <Typography variant="span">Adicionar Selo</Typography>
            <svg
              width="5"
              height="9"
              viewBox="0 0 5 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.146447 8.85355C-0.0488155 8.65829 -0.0488155 8.34171 0.146447 8.14645L3.79289 4.5L0.146447 0.853553C-0.0488154 0.658291 -0.0488154 0.341708 0.146447 0.146446C0.341709 -0.0488157 0.658291 -0.0488157 0.853554 0.146446L4.85355 4.14645C5.04882 4.34171 5.04882 4.65829 4.85355 4.85355L0.853553 8.85355C0.658291 9.04882 0.341709 9.04882 0.146447 8.85355Z"
                fill="white"
              />
            </svg>
            <input
              type="file"
              hidden
              id="img"
              accept="image/png, image/jpeg, image/gif"
              onChange={(e) => {
                setSeal({ ...seal, image: e.target.files[0] });
                setFiles({ ...files, image: e.target.files[0] });
              }}
            />
          </label>
        </div>
      </div>

      {isVisible && (
        <div className={style.filesPreview}>
          <Typography variant="h6">Arquivos</Typography>

          <div className={style.containerPreview}>
            {files.csv && (
              <div className={style.preview}>
                <svg
                  width="24"
                  height="21"
                  viewBox="0 0 24 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.6002 7.5H18.6002C17.6078 7.5 16.8002 6.827 16.8002 6V2.5H7.2002V18.5H21.6002V7.5Z"
                    fill="white"
                  />
                  <path
                    d="M21.6 6.50003V6.20703L18 3.20703V6.00003C18 6.27503 18.27 6.50003 18.6 6.50003H21.6Z"
                    fill="white"
                  />
                  <path
                    opacity="0.64"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22.4484 5.5L18 1.793C17.775 1.60545 17.4698 1.50006 17.1516 1.5H7.2C6.88174 1.5 6.57652 1.60536 6.35147 1.79289C6.12643 1.98043 6 2.23478 6 2.5V18.5C6 18.7652 6.12643 19.0196 6.35147 19.2071C6.57652 19.3946 6.88174 19.5 7.2 19.5H21.6C21.9183 19.5 22.2235 19.3946 22.4485 19.2071C22.6736 19.0196 22.8 18.7652 22.8 18.5V6.207C22.7999 5.9418 22.6735 5.68749 22.4484 5.5ZM21.6 6.207V6.5H18.6C18.441 6.49974 18.2885 6.44697 18.1761 6.35326C18.0636 6.25955 18.0003 6.13253 18 6V3.207L21.6 6.207ZM7.2 2.7V18.3C7.2 18.41 7.308 18.5 7.44 18.5H21.36C21.4236 18.5 21.4847 18.4789 21.5297 18.4414C21.5747 18.4039 21.6 18.353 21.6 18.3V7.5H18.6C18.1226 7.5 17.6648 7.34196 17.3272 7.06066C16.9896 6.77936 16.8 6.39782 16.8 6V2.5H7.44C7.37635 2.5 7.3153 2.52107 7.27029 2.55858C7.22529 2.59609 7.2 2.64696 7.2 2.7Z"
                    fill="#605E5C"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.0004 12.5H16.2004C16.5304 12.5 16.8004 12.725 16.8004 13C16.8004 13.275 16.5304 13.5 16.2004 13.5H15.0004C14.8414 13.4997 14.6889 13.447 14.5765 13.3533C14.464 13.2596 14.4007 13.1325 14.4004 13C14.4004 12.725 14.6704 12.5 15.0004 12.5ZM18.6004 12.5H19.8004C20.1304 12.5 20.4004 12.725 20.4004 13C20.4004 13.275 20.1304 13.5 19.8004 13.5H18.6004C18.4414 13.4997 18.2889 13.447 18.1765 13.3533C18.064 13.2596 18.0007 13.1325 18.0004 13C18.0004 12.725 18.2704 12.5 18.6004 12.5Z"
                    fill="#134A2C"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.0004 10.5H16.2004C16.5304 10.5 16.8004 10.725 16.8004 11C16.8004 11.275 16.5304 11.5 16.2004 11.5H15.0004C14.8414 11.4997 14.6889 11.447 14.5765 11.3533C14.464 11.2596 14.4007 11.1325 14.4004 11C14.4004 10.725 14.6704 10.5 15.0004 10.5ZM18.6004 10.5H19.8004C20.1304 10.5 20.4004 10.725 20.4004 11C20.4004 11.275 20.1304 11.5 19.8004 11.5H18.6004C18.4414 11.4997 18.2889 11.447 18.1765 11.3533C18.064 11.2596 18.0007 11.1325 18.0004 11C18.0004 10.725 18.2704 10.5 18.6004 10.5Z"
                    fill="#21A366"
                  />
                  <path
                    d="M19.8 8.5H18.6C18.27 8.5 18 8.725 18 9C18 9.275 18.27 9.5 18.6 9.5H19.8C20.13 9.5 20.4 9.275 20.4 9C20.4 8.725 20.13 8.5 19.8 8.5Z"
                    fill="#33C481"
                  />
                  <path
                    d="M16.2004 8.5H15.0004C14.6704 8.5 14.4004 8.725 14.4004 9C14.4004 9.275 14.6704 9.5 15.0004 9.5H16.2004C16.5304 9.5 16.8004 9.275 16.8004 9C16.8004 8.725 16.5304 8.5 16.2004 8.5Z"
                    fill="#21A366"
                  />
                  <path
                    d="M2.4002 16.5H12.0002C12.3185 16.5 12.6237 16.3946 12.8487 16.2071C13.0738 16.0196 13.2002 15.7652 13.2002 15.5V7.5C13.2002 7.23478 13.0738 6.98043 12.8487 6.79289C12.6237 6.60536 12.3185 6.5 12.0002 6.5H2.4002C2.08194 6.5 1.77671 6.60536 1.55167 6.79289C1.32662 6.98043 1.2002 7.23478 1.2002 7.5V15.5C1.2002 15.7652 1.32662 16.0196 1.55167 16.2071C1.77671 16.3946 2.08194 16.5 2.4002 16.5Z"
                    fill="#107C41"
                  />
                  <path
                    d="M5.52742 14.5L9.97582 8.5H8.58022L4.07422 14.5H5.52742Z"
                    fill="white"
                  />
                  <path
                    d="M8.84857 14.5L4.40137 8.5H5.79577L10.3006 14.5H8.84857Z"
                    fill="white"
                  />
                </svg>

                <div data-element="preview-content">
                  <Typography variant="h6">{files.csv.name}</Typography>
                  <Typography variant="subtitle2">{files.csv.size}</Typography>
                </div>

                <Button
                  data-element="remove"
                  variant="outlined"
                  onClick={() => {
                    setFiles({
                      ...files,
                      csv: null,
                    });
                    setSeal({
                      title: "",
                      description: "",
                      date_start: "",
                      date_end: "",
                      type: "",
                      color: FIXED_FONT_COLOR_FLAG,
                      background: FIXED_BACKGROUND_FLAG,
                      status: "",
                      file: "",
                      csv: "",
                      time_start: "",
                      time_end: "",
                    });
                  }}
                >
                  <Close />
                </Button>
              </div>
            )}

            {files.image && (
              <div className={style.preview}>
                {files.image && (
                  <img
                    src={URL.createObjectURL(files.image)}
                    alt={files.image.name}
                  />
                )}

                <div data-element="preview-content">
                  <Typography variant="h6">{files.image.name}</Typography>
                  <Typography variant="subtitle2">
                    {files.image.size}
                  </Typography>
                </div>

                <Button
                  data-element="remove"
                  variant="outlined"
                  onClick={() => {
                    setFiles({
                      ...files,
                      image: null,
                    });
                    setSeal({
                      title: "",
                      description: "",
                      date_start: "",
                      date_end: "",
                      type: "",
                      color: FIXED_FONT_COLOR_FLAG,
                      background: FIXED_BACKGROUND_FLAG,
                      status: "",
                      file: "",
                      csv: "",
                      time_start: "",
                      time_end: "",
                    });
                  }}
                >
                  <Close />
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </Grid>
  );
};

AddFile.propTypes = {
  seal: PropTypes.object,
  setFile: PropTypes.func,
};

export default AddFile;
